<template>
  <WidgetVue
    title="Smart Reading"
    desc="Read all reviews with AI based highlighted Sentences"
  >
    <div id="ReviewPanelHolder">
      <div id="ReviewPanel">
        <div id="reviews">
          <div class="row">
            <div class="row">
              <div class="row">
                <div class="col">
                  <span v-if="searchKeyword">
                    Reviews about the keyword
                    <b style="background-color: orange">{{ searchKeyword }}</b>
                  </span>
                  <span v-else> All Reviews </span>
                  <div class="search-container">
                    <input
                      type="text"
                      v-model="searchKeyword"
                      @input="filterReviews"
                      placeholder="Search by keyword"
                      list="mfkeywords"
                    />
                    <datalist id="mfkeywords">
                      <!-- Populate the datalist with unique categories -->
                      <option v-for="item in datum.wf" :key="item.word">
                        {{ item.word }}
                      </option>
                    </datalist>
                  </div>
                </div>
                <div class="col">
                  <div id="slider" class="row text-center">
                    <div class="col">
                      <!-- Code Block A: Slider -->
                      <input
                        type="range"
                        v-model="sentiment_treshold"
                        min="0"
                        max="0.99"
                        step="0.01"
                        class="m-3"
                      />

                      <InfoIcon>
                        The sentiment highlighting treshold helps to make more
                        sharp highlighting for the sentiment scores. it is
                        between the 0 and 90. Default value is 50% which is all
                        sentences which score is bigger than %50 will be green
                        😃 and lesser than -%50 will be red 😑. Rest of it will
                        not highlighted because they are being accepted as
                        neutral.
                      </InfoIcon>

                      <p>
                        Sentiment highlighting treshold %:
                        {{ sentiment_treshold * 100 }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <p>Some reviews are not visible due to performance.</p>
            </div>
            <div class="col-md-6">
              <div class="rowtitle">Reviews</div>
              <div class="rowdesc">Positive reviews</div>

              <div class="revcards">
                <RevCard
                  v-for="dfitem in filteredPosReviews"
                  v-bind:key="dfitem"
                  :rev="dfitem"
                  :review_site_logo="datum.desc.review_site"
                  :year="dfitem.year"
                  :month="dfitem.month"
                  :searchKeyword="searchKeyword"
                  :green_treshold="sentiment_treshold"
                  :red_treshold="sentiment_treshold"
                >
                </RevCard>
              </div>
            </div>
            <div class="col-md-6">
              <div class="rowtitle">Needs attention</div>
              <div class="rowdesc">Negative reviews</div>

              <div class="revcards">
                <RevCard
                  v-for="dfitem in filteredNegReviews"
                  v-bind:key="dfitem"
                  :rev="dfitem"
                  :review_site_logo="datum.desc.review_site"
                  :year="dfitem.year"
                  :month="dfitem.month"
                  :searchKeyword="searchKeyword"
                  :green_treshold="sentiment_treshold"
                  :red_treshold="sentiment_treshold"
                >
                </RevCard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </WidgetVue>
</template>

<script>
import RevCard from "@/components/RevCard.vue";
import InfoIcon from "@/components/InfoIcon.vue";
import WidgetVue from "@/components/WidgetVue.vue";

export default {
  props: ["datum_neg_df", "datum_pos_df", "datum"],
  components: {
    RevCard,
    InfoIcon,
    WidgetVue,
  },
  data() {
    return {
      searchKeyword: "",
      sentiment_treshold: 0.5,
    };
  },
  computed: {
    filteredPosReviews() {
      if (this.searchKeyword.length < 1) {
        return this.datum_pos_df;
      } else {
        return this.filterReviewsByKeyword(this.datum_pos_df);
      }
    },
    filteredNegReviews() {
      if (this.searchKeyword.length < 1) {
        return this.datum_neg_df;
      } else {
        return this.filterReviewsByKeyword(this.datum_neg_df);
      }
    },
  },
  methods: {
    filterReviewsByKeyword(reviews) {
      if (!this.searchKeyword) return reviews;

      const cleanedKeyword = this.searchKeyword.replace(/[^a-zA-Z]/g, ""); // Keep only alphanumeric characters

      const keywordRegex = new RegExp(cleanedKeyword, "gi");

      return reviews.filter((dfitem) => {
        // Check for conditions to filter reviews
        if (keywordRegex.test(dfitem.sentlabel)) {
          return true; // Keyword found in sentlabel
        }

        // Check for keyword in all sentences within the sentiment array
        const sentimentArray = dfitem.sentlemma.sentiment || [];

        for (let i = 0; i < sentimentArray.length; i++) {
          const sentence = sentimentArray[i][0];
          if (keywordRegex.test(sentence)) {
            return true; // Keyword found in the current sentence
          }
        }

        return false; // Keyword not found in sentlabel or any sentence
      });
    },
    filterReviews() {
      // Implement the logic to filter reviews based on the searchKeyword
      this.$emit("filter-reviews", this.searchKeyword);
    },
  },
};
</script>
